import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import { TreeSpeciesRecord } from "../../../type/treeSpecies";
import useAxios from "../../../hook/useAxios";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";
import WarningRedAlert from "../../ErrorAndAlert/WarningRedAlert";
import { defaultLang, secondLang } from "../../../utils";

const SpeciesTableItem: React.FC<{
  speciesItem: TreeSpeciesRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ speciesItem, fetchData: propFetchData, lastIndex }) => {
  const { t, i18n } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/species/${speciesItem.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.The record deleted successfully")}`,
    true,
    true
  );

  useEffect(() => {
    if (deleteR) {
      propFetchData();
      isShowDelete(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (speciesItem.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t("Message.You can’t delete the species. It is used in planting.")
      );
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };
  const name =
    speciesItem.name_transes[secondLang] === ""
      ? speciesItem.name_transes[defaultLang]
      : speciesItem.name_transes[secondLang];

  const scientificName =
    speciesItem.scientific_name_transes[secondLang] === ""
      ? speciesItem.scientific_name_transes[defaultLang]
      : speciesItem.scientific_name_transes[secondLang];

  const botanicalFamily =
    speciesItem.botanical_family_transes?.[secondLang] === ""
      ? speciesItem.botanical_family_transes?.[defaultLang]
      : speciesItem.botanical_family_transes?.[secondLang];

  const type =
    speciesItem.type_transes[secondLang] === ""
      ? speciesItem.type_transes[defaultLang]
      : speciesItem.type_transes[secondLang];

  const abundance =
    speciesItem.abundance_transes[secondLang] === ""
      ? speciesItem.abundance_transes[defaultLang]
      : speciesItem.abundance_transes[secondLang];

  const active =
    i18n.language === secondLang
      ? speciesItem.is_active_transes[secondLang]
      : speciesItem.is_active_transes[defaultLang];

  return (
    <Fragment>
      <TableCell align="left">
        {i18n.language === secondLang
          ? name
          : speciesItem.name_transes[defaultLang]}
      </TableCell>
      <TableCell align="left">
        {i18n.language === secondLang
          ? scientificName
          : speciesItem.scientific_name_transes[defaultLang]}
      </TableCell>
      <TableCell align="left">
        {i18n.language === secondLang
          ? botanicalFamily
          : speciesItem.botanical_family_transes?.[defaultLang]}
      </TableCell>
      <TableCell align="left">
        {i18n.language === secondLang
          ? type
          : speciesItem.type_transes[defaultLang]}
      </TableCell>
      <TableCell align="left">
        {i18n.language === secondLang
          ? abundance
          : speciesItem.abundance_transes[defaultLang]}
      </TableCell>
      <TableCell>
        <p
          className={`${
            speciesItem.is_active_transes[secondLang] === "Active"
              ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
              : "bg-ph-toggle-bg-red text-ph-red-warning"
          } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>
      <TableCell align="right">
        <ActionItem
          delete={true}
          deleteAction={deleteAction}
          editLink={`/setting/tree-species/edit-species/${speciesItem.slug}`}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={t("Tree Species.Tree species")}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
    </Fragment>
  );
};

export default SpeciesTableItem;
